/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const CwcSeriesData = $root.CwcSeriesData = (() => {

    /**
     * Properties of a CwcSeriesData.
     * @exports ICwcSeriesData
     * @interface ICwcSeriesData
     * @property {number|null} [id] CwcSeriesData id
     * @property {number|null} [startIndex] CwcSeriesData startIndex
     * @property {Array.<number>|null} [values] CwcSeriesData values
     */

    /**
     * Constructs a new CwcSeriesData.
     * @exports CwcSeriesData
     * @classdesc Represents a CwcSeriesData.
     * @implements ICwcSeriesData
     * @constructor
     * @param {ICwcSeriesData=} [properties] Properties to set
     */
    function CwcSeriesData(properties) {
        this.values = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CwcSeriesData id.
     * @member {number} id
     * @memberof CwcSeriesData
     * @instance
     */
    CwcSeriesData.prototype.id = 0;

    /**
     * CwcSeriesData startIndex.
     * @member {number} startIndex
     * @memberof CwcSeriesData
     * @instance
     */
    CwcSeriesData.prototype.startIndex = 0;

    /**
     * CwcSeriesData values.
     * @member {Array.<number>} values
     * @memberof CwcSeriesData
     * @instance
     */
    CwcSeriesData.prototype.values = $util.emptyArray;

    /**
     * Creates a new CwcSeriesData instance using the specified properties.
     * @function create
     * @memberof CwcSeriesData
     * @static
     * @param {ICwcSeriesData=} [properties] Properties to set
     * @returns {CwcSeriesData} CwcSeriesData instance
     */
    CwcSeriesData.create = function create(properties) {
        return new CwcSeriesData(properties);
    };

    /**
     * Encodes the specified CwcSeriesData message. Does not implicitly {@link CwcSeriesData.verify|verify} messages.
     * @function encode
     * @memberof CwcSeriesData
     * @static
     * @param {ICwcSeriesData} message CwcSeriesData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CwcSeriesData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.id);
        if (message.startIndex != null && Object.hasOwnProperty.call(message, "startIndex"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.startIndex);
        if (message.values != null && message.values.length) {
            writer.uint32(/* id 3, wireType 2 =*/26).fork();
            for (let i = 0; i < message.values.length; ++i)
                writer.double(message.values[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified CwcSeriesData message, length delimited. Does not implicitly {@link CwcSeriesData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CwcSeriesData
     * @static
     * @param {ICwcSeriesData} message CwcSeriesData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CwcSeriesData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CwcSeriesData message from the specified reader or buffer.
     * @function decode
     * @memberof CwcSeriesData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CwcSeriesData} CwcSeriesData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CwcSeriesData.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CwcSeriesData();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.uint32();
                    break;
                }
            case 2: {
                    message.startIndex = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.values && message.values.length))
                        message.values = [];
                    if ((tag & 7) === 2) {
                        let end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.values.push(reader.double());
                    } else
                        message.values.push(reader.double());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CwcSeriesData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CwcSeriesData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CwcSeriesData} CwcSeriesData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CwcSeriesData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CwcSeriesData message.
     * @function verify
     * @memberof CwcSeriesData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CwcSeriesData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isInteger(message.id))
                return "id: integer expected";
        if (message.startIndex != null && message.hasOwnProperty("startIndex"))
            if (!$util.isInteger(message.startIndex))
                return "startIndex: integer expected";
        if (message.values != null && message.hasOwnProperty("values")) {
            if (!Array.isArray(message.values))
                return "values: array expected";
            for (let i = 0; i < message.values.length; ++i)
                if (typeof message.values[i] !== "number")
                    return "values: number[] expected";
        }
        return null;
    };

    /**
     * Creates a CwcSeriesData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CwcSeriesData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CwcSeriesData} CwcSeriesData
     */
    CwcSeriesData.fromObject = function fromObject(object) {
        if (object instanceof $root.CwcSeriesData)
            return object;
        let message = new $root.CwcSeriesData();
        if (object.id != null)
            message.id = object.id >>> 0;
        if (object.startIndex != null)
            message.startIndex = object.startIndex >>> 0;
        if (object.values) {
            if (!Array.isArray(object.values))
                throw TypeError(".CwcSeriesData.values: array expected");
            message.values = [];
            for (let i = 0; i < object.values.length; ++i)
                message.values[i] = Number(object.values[i]);
        }
        return message;
    };

    /**
     * Creates a plain object from a CwcSeriesData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CwcSeriesData
     * @static
     * @param {CwcSeriesData} message CwcSeriesData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CwcSeriesData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.values = [];
        if (options.defaults) {
            object.id = 0;
            object.startIndex = 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.startIndex != null && message.hasOwnProperty("startIndex"))
            object.startIndex = message.startIndex;
        if (message.values && message.values.length) {
            object.values = [];
            for (let j = 0; j < message.values.length; ++j)
                object.values[j] = options.json && !isFinite(message.values[j]) ? String(message.values[j]) : message.values[j];
        }
        return object;
    };

    /**
     * Converts this CwcSeriesData to JSON.
     * @function toJSON
     * @memberof CwcSeriesData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CwcSeriesData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CwcSeriesData
     * @function getTypeUrl
     * @memberof CwcSeriesData
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CwcSeriesData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CwcSeriesData";
    };

    return CwcSeriesData;
})();

export const CwcDataSet = $root.CwcDataSet = (() => {

    /**
     * Properties of a CwcDataSet.
     * @exports ICwcDataSet
     * @interface ICwcDataSet
     * @property {Array.<ICwcSeriesData>|null} [series] CwcDataSet series
     */

    /**
     * Constructs a new CwcDataSet.
     * @exports CwcDataSet
     * @classdesc Represents a CwcDataSet.
     * @implements ICwcDataSet
     * @constructor
     * @param {ICwcDataSet=} [properties] Properties to set
     */
    function CwcDataSet(properties) {
        this.series = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CwcDataSet series.
     * @member {Array.<ICwcSeriesData>} series
     * @memberof CwcDataSet
     * @instance
     */
    CwcDataSet.prototype.series = $util.emptyArray;

    /**
     * Creates a new CwcDataSet instance using the specified properties.
     * @function create
     * @memberof CwcDataSet
     * @static
     * @param {ICwcDataSet=} [properties] Properties to set
     * @returns {CwcDataSet} CwcDataSet instance
     */
    CwcDataSet.create = function create(properties) {
        return new CwcDataSet(properties);
    };

    /**
     * Encodes the specified CwcDataSet message. Does not implicitly {@link CwcDataSet.verify|verify} messages.
     * @function encode
     * @memberof CwcDataSet
     * @static
     * @param {ICwcDataSet} message CwcDataSet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CwcDataSet.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.series != null && message.series.length)
            for (let i = 0; i < message.series.length; ++i)
                $root.CwcSeriesData.encode(message.series[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified CwcDataSet message, length delimited. Does not implicitly {@link CwcDataSet.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CwcDataSet
     * @static
     * @param {ICwcDataSet} message CwcDataSet message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CwcDataSet.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CwcDataSet message from the specified reader or buffer.
     * @function decode
     * @memberof CwcDataSet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CwcDataSet} CwcDataSet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CwcDataSet.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CwcDataSet();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.series && message.series.length))
                        message.series = [];
                    message.series.push($root.CwcSeriesData.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CwcDataSet message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CwcDataSet
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CwcDataSet} CwcDataSet
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CwcDataSet.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CwcDataSet message.
     * @function verify
     * @memberof CwcDataSet
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CwcDataSet.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.series != null && message.hasOwnProperty("series")) {
            if (!Array.isArray(message.series))
                return "series: array expected";
            for (let i = 0; i < message.series.length; ++i) {
                let error = $root.CwcSeriesData.verify(message.series[i]);
                if (error)
                    return "series." + error;
            }
        }
        return null;
    };

    /**
     * Creates a CwcDataSet message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CwcDataSet
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CwcDataSet} CwcDataSet
     */
    CwcDataSet.fromObject = function fromObject(object) {
        if (object instanceof $root.CwcDataSet)
            return object;
        let message = new $root.CwcDataSet();
        if (object.series) {
            if (!Array.isArray(object.series))
                throw TypeError(".CwcDataSet.series: array expected");
            message.series = [];
            for (let i = 0; i < object.series.length; ++i) {
                if (typeof object.series[i] !== "object")
                    throw TypeError(".CwcDataSet.series: object expected");
                message.series[i] = $root.CwcSeriesData.fromObject(object.series[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a CwcDataSet message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CwcDataSet
     * @static
     * @param {CwcDataSet} message CwcDataSet
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CwcDataSet.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.series = [];
        if (message.series && message.series.length) {
            object.series = [];
            for (let j = 0; j < message.series.length; ++j)
                object.series[j] = $root.CwcSeriesData.toObject(message.series[j], options);
        }
        return object;
    };

    /**
     * Converts this CwcDataSet to JSON.
     * @function toJSON
     * @memberof CwcDataSet
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CwcDataSet.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CwcDataSet
     * @function getTypeUrl
     * @memberof CwcDataSet
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CwcDataSet.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CwcDataSet";
    };

    return CwcDataSet;
})();

export { $root as default };
